// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Oy94x","title":"Info_title__1sS4x","selects":"Info_selects__1av8i","requiredAsterisk":"Info_requiredAsterisk__1xRZ2"};